import React, { useState, useEffect } from 'react';
import api from '../api';

export default function GuiaMenuFixo() {
  const [menuFixo, setMenuFixo] = useState([]);
  const [tamanhos, setTamanhos] = useState([]);
  const [recheios, setRecheios] = useState([]);
  const [fichasMassa, setFichasMassa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const [modalAberto, setModalAberto] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [filtroTamanho, setFiltroTamanho] = useState('');

  // Modal state — adição
  const [tamanhoSelecionado, setTamanhoSelecionado] = useState('');
  const [combinacoesSelecionadas, setCombinacoesSelecionadas] = useState(new Set());

  // Modal state — edição de item
  const [editandoItem, setEditandoItem] = useState(null); // { id, tamanho_id, massa_ficha_id, recheio_id, tamanho_nome }
  const [editMassaId, setEditMassaId] = useState('');
  const [editRecheioId, setEditRecheioId] = useState('');
  const [salvandoEdicao, setSalvandoEdicao] = useState(false);

  useEffect(() => { carregarDados(); }, []);

  async function carregarDados() {
    setLoading(true);
    try {
      const [resMenu, resTamanhos, resRecheios, resFichas] = await Promise.all([
        api.get('/guia/menu-fixo'),
        api.get('/guia/tamanhos?tipo=congelado'),
        api.get('/guia/recheios'),
        api.get('/fichas/api/fichas-tecnicas'),
      ]);
      setMenuFixo(resMenu.data);
      setTamanhos(resTamanhos.data);
      setRecheios(resRecheios.data);
      setFichasMassa((resFichas.data?.fichas || []).filter(f => f.categoria === 'Massas de Bolo'));
    } catch {
      setErro('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  }

  function abrirNovo() {
    setTamanhoSelecionado('');
    setCombinacoesSelecionadas(new Set());
    setModalAberto(true);
  }

  function fecharModal() {
    setModalAberto(false);
  }

  function abrirEditar(m) {
    setEditandoItem(m);
    setEditMassaId(m.massa_ficha_id);
    setEditRecheioId(m.recheio_id);
  }

  function fecharEdicao() {
    setEditandoItem(null);
  }

  async function salvarEdicao(e) {
    e.preventDefault();
    setSalvandoEdicao(true);
    try {
      await api.delete(`/guia/menu-fixo/${editandoItem.id}`);
      await api.post('/guia/menu-fixo', {
        tamanho_id: editandoItem.tamanho_id,
        massa_ficha_id: Number(editMassaId),
        recheio_id: Number(editRecheioId),
      });
      setSucesso('Item atualizado!');
      fecharEdicao();
      carregarDados();
    } catch (e) {
      setErro(e.response?.data?.erro || 'Erro ao atualizar item');
    } finally {
      setSalvandoEdicao(false);
    }
  }

  // Retorna as massas permitidas do tamanho selecionado
  function massasDoTamanho() {
    if (!tamanhoSelecionado) return fichasMassa;
    const t = tamanhos.find(t => t.id === Number(tamanhoSelecionado));
    if (!t?.massas_permitidas?.length) return fichasMassa;
    const ids = t.massas_permitidas.map(m => m.ficha_tecnica_id);
    return fichasMassa.filter(f => ids.includes(f.id));
  }

  // Retorna os recheios permitidos do tamanho selecionado
  function recheiosDoTamanho() {
    if (!tamanhoSelecionado) return recheios;
    const t = tamanhos.find(t => t.id === Number(tamanhoSelecionado));
    if (!t?.recheios_permitidos?.length) return recheios;
    const ids = t.recheios_permitidos.map(r => r.recheio_id);
    return recheios.filter(r => ids.includes(r.id));
  }

  // Já salvas para este tamanho (para desabilitar duplicatas)
  function jaExiste(massaId, recheioId) {
    return menuFixo.some(
      m => m.tamanho_id === Number(tamanhoSelecionado) &&
           m.massa_ficha_id === massaId &&
           m.recheio_id === recheioId
    );
  }

  function chave(massaId, recheioId) {
    return `${massaId}_${recheioId}`;
  }

  function toggleCombinacao(massaId, recheioId) {
    const k = chave(massaId, recheioId);
    setCombinacoesSelecionadas(prev => {
      const next = new Set(prev);
      next.has(k) ? next.delete(k) : next.add(k);
      return next;
    });
  }

  function selecionarTodas() {
    const massas = massasDoTamanho();
    const rechs = recheiosDoTamanho();
    const next = new Set();
    massas.forEach(m => rechs.forEach(r => {
      if (!jaExiste(m.id, r.id)) next.add(chave(m.id, r.id));
    }));
    setCombinacoesSelecionadas(next);
  }

  function limparSelecao() {
    setCombinacoesSelecionadas(new Set());
  }

  async function salvar(e) {
    e.preventDefault();
    if (!tamanhoSelecionado) return;
    if (combinacoesSelecionadas.size === 0) {
      setErro('Selecione pelo menos uma combinação');
      return;
    }

    setSalvando(true);
    setSucesso('');
    setErro('');

    try {
      await Promise.all([...combinacoesSelecionadas].map(k => {
        const [massaId, recheioId] = k.split('_').map(Number);
        return api.post('/guia/menu-fixo', {
          tamanho_id: Number(tamanhoSelecionado),
          massa_ficha_id: massaId,
          recheio_id: recheioId,
        });
      }));
      setSucesso(`${combinacoesSelecionadas.size} ${combinacoesSelecionadas.size === 1 ? 'item adicionado' : 'itens adicionados'} ao menu fixo!`);
      fecharModal();
      carregarDados();
    } catch (e) {
      setErro(e.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  }

  async function remover(id) {
    if (!window.confirm('Remover este item do menu fixo?')) return;
    try {
      await api.delete(`/guia/menu-fixo/${id}`);
      setSucesso('Item removido.');
      carregarDados();
    } catch {
      setErro('Erro ao remover item');
    }
  }

  const itensFiltrados = filtroTamanho
    ? menuFixo.filter(m => m.tamanho_id === Number(filtroTamanho))
    : menuFixo;

  const itensPorTamanho = tamanhos.reduce((acc, t) => {
    acc[t.id] = itensFiltrados.filter(m => m.tamanho_id === t.id);
    return acc;
  }, {});

  const tamanhosFiltrados = filtroTamanho
    ? tamanhos.filter(t => t.id === Number(filtroTamanho))
    : tamanhos;

  const massasModal = massasDoTamanho();
  const recheiosModal = recheiosDoTamanho();

  return (
    <div className="p-6 max-w-5xl mx-auto">

      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-700">Menu Fixo — Congelados</h1>
          <p className="text-gray-400 text-sm mt-1">Combinações massa + recheio disponíveis para bolos congelados</p>
        </div>
        <button onClick={abrirNovo}
          className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm">
          + Adicionar Itens
        </button>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-lg px-4 py-3 text-sm text-blue-700 mb-5">
        <strong>Menu fixo:</strong> define quais combinações de massa + recheio existem para cada
        tamanho congelado. Esses itens aparecem na tela de Produção Semanal como opções fixas.
      </div>

      {erro && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 text-sm">{erro}</div>}
      {sucesso && <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-4 text-sm">{sucesso}</div>}

      {/* Filtro */}
      {tamanhos.length > 1 && (
        <div className="mb-5">
          <div className="relative max-w-xs">
            <span className="absolute left-3 top-2.5 text-gray-400 text-sm">❄️</span>
            <select value={filtroTamanho} onChange={e => setFiltroTamanho(e.target.value)}
              className="w-full pl-9 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-pink-300 appearance-none">
              <option value="">Todos os tamanhos</option>
              {tamanhos.map(t => <option key={t.id} value={t.id}>{t.nome} ({t.fatias} fatias)</option>)}
            </select>
          </div>
        </div>
      )}

      {loading ? (
        <div className="text-center py-12 text-gray-400">Carregando...</div>
      ) : tamanhos.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">Nenhum tamanho congelado cadastrado ainda.</p>
          <a href="/guia/tamanhos" className="text-pink-600 hover:underline text-sm mt-1 inline-block">Cadastrar tamanhos</a>
        </div>
      ) : (
        <>
          <div className="space-y-6 mb-6">
            {tamanhosFiltrados.map(t => {
              const itens = itensPorTamanho[t.id] || [];
              return (
                <div key={t.id}>
                  <h3 className="text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
                      ❄️ {t.nome} · {t.fatias} fatias
                      <span className="ml-2 font-normal text-blue-500">
                        ({itens.length} {itens.length === 1 ? 'combinação' : 'combinações'})
                      </span>
                    </span>
                  </h3>

                  {itens.length === 0 ? (
                    <div className="text-center py-6 text-gray-400 text-sm border border-dashed border-gray-200 rounded-lg">
                      Nenhuma combinação cadastrada para este tamanho.
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300 text-sm">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border border-gray-300 px-3 py-2 text-left font-medium text-gray-700">Recheio</th>
                            <th className="border border-gray-300 px-3 py-2 text-left font-medium text-gray-700">Massa</th>
                            <th className="border border-gray-300 px-3 py-2 text-center font-medium text-gray-700" style={{width:'90px'}}>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itens.map(m => (
                            <tr key={m.id} className="hover:bg-blue-50/40 transition-colors">
                              <td className="border border-gray-300 px-3 py-2 font-semibold text-gray-800">{m.recheio_nome}</td>
                              <td className="border border-gray-300 px-3 py-2 text-gray-600">{m.massa_ficha_nome}</td>
                              <td className="border border-gray-300 px-2 py-2">
                                <div className="flex items-center justify-center gap-1">
                                  <button onClick={() => abrirEditar(m)}
                                    className="bg-gray-500 text-white p-1.5 rounded hover:bg-gray-600 transition-colors" title="Editar">✏️</button>
                                  <button onClick={() => remover(m.id)}
                                    className="bg-red-500 text-white p-1.5 rounded hover:bg-red-600 transition-colors" title="Remover">🗑️</button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Rodapé */}
          <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3">
              <span className="font-medium text-gray-700 text-sm">
                Total: {menuFixo.length} {menuFixo.length === 1 ? 'combinação' : 'combinações'} no menu fixo
              </span>
              <div className="flex gap-3 flex-wrap">
                {tamanhos.map(t => {
                  const n = (itensPorTamanho[t.id] || []).length;
                  if (!n) return null;
                  return (
                    <span key={t.id} className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                      ❄️ {t.nome}: {n}
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}

      {/* ── Modal Adição ── */}
      {modalAberto && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-start justify-center z-50 overflow-y-auto py-8">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl mx-4">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-gray-800">Adicionar ao Menu Fixo</h2>
              <button onClick={fecharModal} className="text-gray-400 hover:text-gray-600 text-xl font-bold">×</button>
            </div>

            <form onSubmit={salvar} className="px-6 py-5 space-y-4">
              {/* Tamanho */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tamanho *</label>
                <select value={tamanhoSelecionado}
                  onChange={e => { setTamanhoSelecionado(e.target.value); setCombinacoesSelecionadas(new Set()); }}
                  required
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-300">
                  <option value="">Selecione o tamanho...</option>
                  {tamanhos.map(t => <option key={t.id} value={t.id}>{t.nome} | {t.fatias} fatias ({t.fatias} fatias)</option>)}
                </select>
              </div>

              {/* Grade de combinações */}
              {tamanhoSelecionado && (
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-medium text-gray-700">
                      Selecione as combinações
                    </label>
                    <div className="flex gap-3">
                      <button type="button" onClick={selecionarTodas}
                        className="text-xs text-pink-600 hover:text-pink-800 font-medium">
                        Selecionar todas
                      </button>
                      <button type="button" onClick={limparSelecao}
                        className="text-xs text-gray-400 hover:text-gray-600 font-medium">
                        Limpar
                      </button>
                    </div>
                  </div>

                  {massasModal.length === 0 || recheiosModal.length === 0 ? (
                    <p className="text-sm text-amber-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
                      Este tamanho não tem massas ou recheios cadastrados. Configure no{' '}
                      <a href="/guia/tamanhos" className="underline">cadastro de tamanhos</a>.
                    </p>
                  ) : (
                    <div className="overflow-x-auto border border-gray-100 rounded-xl">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-gray-50 border-b border-gray-100">
                            <th className="text-left px-3 py-2 font-medium text-gray-500 text-xs">
                              Massa \ Recheio
                            </th>
                            {recheiosModal.map(r => (
                              <th key={r.id} className="px-3 py-2 font-medium text-gray-500 text-xs text-center">
                                {r.nome}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                          {massasModal.map(m => (
                            <tr key={m.id} className="hover:bg-gray-50">
                              <td className="px-3 py-2 font-medium text-gray-700 text-xs whitespace-nowrap">
                                {m.nome}
                              </td>
                              {recheiosModal.map(r => {
                                const k = chave(m.id, r.id);
                                const existe = jaExiste(m.id, r.id);
                                const sel = combinacoesSelecionadas.has(k);
                                return (
                                  <td key={r.id} className="px-3 py-2 text-center">
                                    {existe ? (
                                      <span className="text-green-500 text-base" title="Já cadastrado">✓</span>
                                    ) : (
                                      <input
                                        type="checkbox"
                                        checked={sel}
                                        onChange={() => toggleCombinacao(m.id, r.id)}
                                        className="w-4 h-4 accent-pink-600 cursor-pointer"
                                      />
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {combinacoesSelecionadas.size > 0 && (
                    <p className="text-xs text-pink-600 font-medium mt-2">
                      {combinacoesSelecionadas.size} combinação{combinacoesSelecionadas.size > 1 ? 'ões' : ''} selecionada{combinacoesSelecionadas.size > 1 ? 's' : ''}
                    </p>
                  )}
                </div>
              )}

              <div className="flex justify-end gap-3 pt-2 border-t border-gray-100">
                <button type="button" onClick={fecharModal}
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 font-medium">
                  Cancelar
                </button>
                <button type="submit" disabled={salvando || combinacoesSelecionadas.size === 0}
                  className="bg-pink-600 hover:bg-pink-700 disabled:opacity-60 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors">
                  {salvando ? 'Salvando...' : `Adicionar${combinacoesSelecionadas.size > 0 ? ` (${combinacoesSelecionadas.size})` : ''}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* ── Modal Edição ── */}
      {editandoItem && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl mx-4">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <div>
                <h2 className="text-lg font-bold text-gray-800">Editar Item</h2>
                <p className="text-xs text-gray-400 mt-0.5">❄️ {editandoItem.tamanho_nome}</p>
              </div>
              <button onClick={fecharEdicao} className="text-gray-400 hover:text-gray-600 text-xl font-bold">×</button>
            </div>
            <form onSubmit={salvarEdicao} className="px-6 py-5 space-y-4">
              <div>
                <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Recheio *</label>
                <select value={editRecheioId} onChange={e => setEditRecheioId(e.target.value)} required
                  className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white">
                  <option value="">Selecione o recheio...</option>
                  {(() => {
                    const t = tamanhos.find(t => t.id === editandoItem.tamanho_id);
                    const ids = t?.recheios_permitidos?.map(r => r.recheio_id) || [];
                    const lista = ids.length ? recheios.filter(r => ids.includes(r.id)) : recheios;
                    return lista.map(r => <option key={r.id} value={r.id}>{r.nome}</option>);
                  })()}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Massa *</label>
                <select value={editMassaId} onChange={e => setEditMassaId(e.target.value)} required
                  className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white">
                  <option value="">Selecione a massa...</option>
                  {(() => {
                    const t = tamanhos.find(t => t.id === editandoItem.tamanho_id);
                    const ids = t?.massas_permitidas?.map(m => m.ficha_tecnica_id) || [];
                    const lista = ids.length ? fichasMassa.filter(f => ids.includes(f.id)) : fichasMassa;
                    return lista.map(f => <option key={f.id} value={f.id}>{f.nome}</option>);
                  })()}
                </select>
              </div>
              <div className="flex justify-end gap-3 pt-2 border-t border-gray-100">
                <button type="button" onClick={fecharEdicao}
                  className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 font-medium">Cancelar</button>
                <button type="submit" disabled={salvandoEdicao}
                  className="bg-pink-500 hover:bg-pink-600 disabled:opacity-50 text-white px-5 py-2 rounded-xl text-sm font-semibold transition-all shadow-sm">
                  {salvandoEdicao ? 'Salvando...' : 'Salvar alterações'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}